import React, { useState } from "react";
import { Link } from "react-router-dom";
import { 
  HiOutlineEnvelope, HiOutlineArrowRight, 
  HiOutlineChevronLeft, HiOutlineSparkles 
} from "react-icons/hi2";
import "../asset/css/login.css";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResetRequest = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Endpoint to trigger the reset email
      const response = await axios.post(`${baseurl}forgotPassword`, {
        email: email
      });

      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Link Sent!',
          text: 'Please check your email inbox for the reset link.',
          confirmButtonColor: "#166070"
        });
        setEmail(""); // Clear input
      }
    } catch (err) {
      console.error("Reset Error:", err.response?.data?.error || err.message);
      
      Swal.fire({
        icon: 'error',
        title: 'Request Failed',
        text: err.response?.data?.error || "We couldn't find an account with that email.",
        confirmButtonColor: "#166070"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-hero-wrapper">
      <div className="container login-main-container">
        <div className="login-card shadow-2xl">
          <div className="row g-0 h-100">
            
            {/* --- LEFT HERO BRANDING --- */}
            <div className="col-lg-6 d-none d-lg-block side-hero-image">
              <div className="side-hero-overlay p-5 d-flex flex-column justify-content-center">
                <div className="hero-badge mb-4">
                  <HiOutlineSparkles className="me-2" /> Security First
                </div>
                <h1 className="display-4 fw-bold text-white mb-4">
                  Don't <br /> Worry.
                </h1>
                <p className="text-white-50 lead mb-5">
                  It happens to the best of us. Provide your email and we'll help you get back to your adventure in no time.
                </p>
              </div>
            </div>

            {/* --- RIGHT FORM SECTION --- */}
            <div className="col-lg-6 bg-white p-4 p-md-5 d-flex flex-column justify-content-center">
              <div className="form-content mx-auto" style={{maxWidth: "400px", width: "100%"}}>
                
                <Link to="/login" className="text-decoration-none text-teal small fw-bold mb-4 d-inline-block">
                  <HiOutlineChevronLeft className="me-1" /> Back to Login
                </Link>

                <div className="text-start mb-5">
                  <h2 className="fw-bold text-dark">Forgot Password?</h2>
                  <p className="text-muted">Enter the email address associated with your account.</p>
                </div>

                <form onSubmit={handleResetRequest}>
                  <div className="form-floating-custom mb-4">
                    <label className="small fw-bold text-uppercase text-teal">Email Address</label>
                    <div className="input-with-icon">
                      <HiOutlineEnvelope className="icon" />
                      <input 
                        type="email" 
                        placeholder="e.g. wanderer@travel.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required 
                      />
                    </div>
                  </div>

                  <button 
                    type="submit" 
                    className="btn-hero-login w-100 mt-2"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Sending Link..." : "Send Reset Link"} 
                    {!isSubmitting && <HiOutlineArrowRight className="ms-2" />}
                  </button>
                </form>

                <div className="mt-5 p-4 rounded-3 bg-light">
                  <p className="small text-muted mb-0">
                    <strong>Note:</strong> If you don't see the email in your inbox within a few minutes, please check your spam folder.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;